import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Grid,
  TextField,
  makeStyles,
  Dialog,
  DialogActions,
  Checkbox,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { connect } from "react-redux";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ContentPasteIcon from "@material-ui/icons/Assignment";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import CustomButton from "./CustomButton";
import GridSelect from "./Grid/GridSelect";
import ContainedLabel from "./Grid/ContainedLabel";
import GridLabel from "./Grid/GridLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowRight from "@material-ui/icons/ArrowRight";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import * as layerAction from "../../../actions/layerAction";
import * as miscAction from "../../../actions/miscAction";
import * as ruleAction from "../../../actions/ruleAction";
import * as _ from "lodash";
import { getS3BucketLayers } from "../../../services/DrawingsService";
import { validateFileName } from "../../../utilities/applicationutils";
import AutoCompleteDropdown from "./AutoCompleteDropDown";
import AutocompleteSelect from "./AutoCompleteSelect";
import sortUpIcon from "../../../assets/images/sort-up.svg";
import sortDownIcon from "../../../assets/images/sort-down.svg";
import sortIcon from "../../../assets/images/sort.svg";
import SortIcon from "./Grid/SortIcon";
import DropdownSelect from "./DropDownSelect";
import WarningPopup from "./warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../../constants/constants";
import ExportRuleLayers from "../../../screens/DownloadCsv/exportRuleLayers";

const SortIconEnum = {
  asc: sortUpIcon,
  desc: sortDownIcon,
  noSort: sortIcon,
};

const windowHeight = window.innerHeight;

const Layers = ({
  title,
  layerState,
  rulesState,
  miscState,
  subTitle,
  getLayers,
  rules,
  getLayerRules,
  updatelayerRules,
  setSnackBar,
  deleteLayerRule,
  dataDescriptionState,
  createLayerRules,
  updateRules,
  onCloseSelected,
  setIsUnsaveChanges = (d) => {},
  copyDrawing = null,
  backupDrawingId = null,
  intl,
  setCopyState,
  copyState,
  drawingName = "",
}) => {
  let template = "60% 10% 10% 14% 6%"; // "53% 10% 15% 15% 7%";

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      marginTop: "50px",
    },
    container: {
      border: "1px solid var(--Brand-color-Light-Grey, #E5E7ED)",
      borderRadius: "4px",
      margin: "0 4px",
    },
    layerContainer: {
      margin: "0 4px",
    },
    gridHeaderColumns: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "10% 40% 20% 20% 10%",
    },
    gridColumns: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "10% 90%",
    },
    gridLayerColumns: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "90% 10%",
    },
    gridLayerColumnsData: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "90% 10%",
      border: "1px solid var(--Brand-color-Light-Grey, #E5E7ED)",
      borderRadius: "4px",
      margin: "2px 0",
    },
    divColumnHeader: {
      width: "100%",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "40% 25% 25% 10%",
    },
    divColumnHeaderLayer: {
      width: "100%",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: template,
    },
    divColumnLayer: {
      width: "100%",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: template,
    },
    divColumn: {
      width: "100%",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "40% 25% 25% 10%",
      border: "1px solid var(--Brand-color-Light-Grey, #E5E7ED);",
      paddingLeft: "4px",
      marginBottom: "4px",
    },
    item: {
      textAlign: "left",
      fontSize: "12px",
    },
    itemLayer: {
      textAlign: "center",
      fontSize: "12px",
    },
    andIcon: {
      color: "#BAC0D0",
      fontSize: "16px",
    },
    addNewRule: {
      color: "#1891F6",
      fontSize: "0.875rem",
      fontWeight: "700",
      border: "none",
      backgroundColor: "transparent",
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      textTransform: "capitalize",
    },
    header: {
      color: "#617080",
      fontSize: "14px",
      fontWeight: "500",
    },
    headerLayer: {
      color: "#617080",
      fontSize: "14px",
      fontWeight: "500",
      textAlign: "center",
    },
  }));

  const classes = useStyles();

  const [fields, setFields] = useState([]);
  const [deleteFields, setDeleteFields] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [selectedLayer, setSelectedLayer] = useState();
  const [layer, setLayer] = useState();
  const [loading, setLoading] = useState(false);
  const [layerLoading, setLayerLoading] = useState(false);
  const [index, setIndex] = useState(0);
  const [ruleIndex, setRuleIndex] = useState(0);
  const [dependencyIndex, setDependencyIndex] = useState(0);
  const [deleteLayerRuleRequests, setDeleteLayerRuleRequests] = useState([]);
  const [deleteLayerDependencyRequests, setDeleteLayerDependencyRequests] =
    useState([]);
  const [
    updatedLayerDependencyRequests,
    setUpdatedDeleteLayerDependencyRequests,
  ] = useState([]);
  const [updateLayers, setUpdateLayers] = useState([]);
  const [deleteFlag, setDeleteFlag] = useState("");
  const [notFoundLayerData, setNotFoundLayerData] = useState([]);

  const [ddList, setDDlist] = useState([]);
  const [backUpFields, setBackUpFields] = useState([]);
  const [backUpLayer, setBackUpLayers] = useState([]);
  const [newBackUpLayer, setNewBackUpLayers] = useState([]);

  useEffect(() => {
    let configValues = dataDescriptionState?.gridData?.data;
    let list = [];
    if (configValues.length > 0) {
      configValues.forEach((item, index) => {
        list.push({
          label: item.ddName,
          value: index,
          ddValues: item.ddValues,
          columnType: item.columnType,
        });
      });
    }
    setDDlist(list);
  }, [dataDescriptionState?.gridData?.data]);

  // useEffect(() => {
  //  // getLayers(rules?.drawingId);
  // }, [rules?.drawingId]);

  // useEffect(() => {
  //   setFields(layerState?.gridData?.data);
  // }, [layerState?.gridData?.data]);

  // useEffect(() => {
  //   setLoading(layerState?.gridData?.isLoading);
  // }, [layerState?.gridData?.isLoading]);

  const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  const findLayersFromS3 = (data) => {
    const idText = "dep";
    const layers = JSON.parse(JSON.stringify(rulesState?.layers?.data?.layers));
    const filteredRemoveData = layers.filter(
      (el) =>
        !data.some(
          (f) =>
            f.layerName.trim().toLowerCase() ===
            el.layerName.trim().toLowerCase()
        )
    );
    const filteredAddData = data.filter(
      (el) =>
        !layers.some(
          (f) =>
            f.layerName.trim().toLowerCase() ===
            el.layerName.trim().toLowerCase()
        )
    );
    const deleteFromDbList = layers.filter(
      (f) =>
        !filteredRemoveData.some(
          (item1) =>
            f.layerId.trim().toLowerCase() ===
            item1.layerId.trim().toLowerCase()
        )
    );
    let addNewlayers = [];
    if (filteredAddData.length > 0) {
      filteredAddData.forEach((item) => {
        const depId = idText.concat(uuidv4());
        const payload = {
          drawingId: rules?.drawingId,
          layerName: item.layerName.trim(),
          alwaysOn: false,
          removeForDxf: false,
          isCompareFullName: false,
          alwaysOff: true,
          layerRules: [],
          isDelete: false,
          disabled: true,
          isAdd: true,
          layerId: depId,
        };
        addNewlayers.push(payload);
      });
    }
    if (filteredRemoveData.length > 0) {
      filteredRemoveData.forEach((element) => {
        element.isAdd = false;
        element.isDelete = true;
        element.alwaysOff = true;
        element.alwaysOn = false;
        element.isCompareFullName = false;
        element.removeForDxf = false;
        element["disabled"] = true;
      });
    }

    const mergeAddedLayers = addNewlayers.concat(deleteFromDbList);
    setDeleteFields(filteredRemoveData);
    setFields(mergeAddedLayers);
    // newFindLayer(data);
    // console.log("mergeAddedLayers: ",mergeAddedLayers)
  };

  const newFindLayer = (data) => {
    const idText = "dep";
    const layers = JSON.parse(JSON.stringify(rulesState?.layers?.data?.layers));

    const s3Layers = data.map((ele) => ele.layerName.trim());
    const dbLayerTemp = layers.map((ele) => ele.layerName.trim());
    let newDBLayer = [];

    let backUpNewLayer = [];

    if (copyDrawing) {
      let findNewDBLayer = [];
      backUpLayer.forEach((ele) => {
        if (dbLayerTemp.includes(ele.layerName.trim())) {
          let d = layers.filter(
            (e) => e.layerName.trim() === ele.layerName.trim()
          );
          let lt = {
            ...d[0],
            drawingId: backupDrawingId,
            layerId: ele.layerId,
            isOld: true,
          };
          findNewDBLayer.push(lt);

          backUpNewLayer.push({ layer: ele.layerName, old: ele, new: lt });
        } else {
          findNewDBLayer.push(ele);
        }
      });

      let tempNewLayerSortFromBackUp = findNewDBLayer.map((e) =>
        e.layerName.trim()
      );

      layers.forEach((ele) => {
        if (
          s3Layers.includes(ele.layerName.trim()) &&
          !tempNewLayerSortFromBackUp.includes(ele.layerName.trim())
        ) {
          const depId = idText.concat(uuidv4());
          let lt = {
            ...ele,
            drawingId: backupDrawingId,
            layerId: depId,
            isOld: false,
          };

          findNewDBLayer.push(lt);
          backUpNewLayer.push({
            layer: ele.layerName,
            old: { ...ele, drawingId: backupDrawingId },
            new: lt,
          });
        }
      });

      newDBLayer = findNewDBLayer;
      setNewBackUpLayers(backUpNewLayer);
    } else {
      newDBLayer = [...layers];
    }

    let dbLayer = newDBLayer.map((ele) => ele.layerName.trim());

    let deletedLayer = [];
    let activeLayer = [];
    let notFoundLayer = [];

    newDBLayer.forEach((item) => {
      if (s3Layers.includes(item.layerName.trim())) {
        activeLayer.push(item);
      } else {
        let tempDeleteLayer = { ...item, disabled: true };
        deletedLayer.push(tempDeleteLayer);
      }
    });

    s3Layers.forEach((item) => {
      if (!dbLayer.includes(item)) {
        const depId = idText.concat(uuidv4());
        notFoundLayer.push({
          layerId: depId,
          isNotFound: true,
          drawingId: rules?.drawingId,
          layerName: item,
          alwaysOn: false,
          removeForDxf: false,
          isCompareFullName: false,
          layerRules: [],
          alwaysOff: true,
          disabled: true,
          isDelete: false,
          isAdd: true,
        });
      }
    });

    const mergeAddedLayers = activeLayer.concat(notFoundLayer);
    // console.log(deletedLayer, mergeAddedLayers, notFoundLayer);
    setDeleteFields(deletedLayer);
    setFields(mergeAddedLayers);
    setNotFoundLayerData(notFoundLayer);
  };

  /* Get layers from s3bucket*/
  const getLayersFromS3 = () => {
    const file = validateFileName(title);

    getS3BucketLayers(miscState?.selectedModel, file)
      .then((response) => {
        const data = response.data;
        const updateData = [];
        if (data.length > 0) {
          data.forEach((item) => {
            updateData.push({ layerName: item.trim() });
          });
        }
        // findLayersFromS3(updateData);
        newFindLayer(updateData);
        setLayerLoading(false);
      })
      .catch((error) => {
        newFindLayer([]);
        setLayerLoading(false);
      });
  };

  /* Preparing update paylod for layes*/
  const prepareRuleLayerRequest = () => {
    const gridData = JSON.parse(JSON.stringify(fields));
    const createLayerRuleRequests = [];
    let createLayerDependencyRequests = [];
    let createNewLayerDependencyRequests = [];
    let createLayerDependencyRequestsExitsLayers = [];
    let updateLayerDependencyRequests = [];
    let createLayerRuleRequestWithDependencies = [];
    let createLayerRequest = [];
    console.log("create payload gridData= ", gridData);
    gridData.length > 0 &&
      gridData.forEach(async (item, index) => {
        const isEmpty = item?.layerId.includes("dep");
        if (!item.alwaysOff) {
          if (!isEmpty) {
            item.layerRules &&
              item.layerRules.length > 0 &&
              item.layerRules.forEach(async (newItem) => {
                if (newItem?.layerRuleId === "") {
                  const layerPayload = {
                    layerId: item?.layerId,
                  };
                  newItem.layerDependencies.length > 0 &&
                    newItem.layerDependencies.forEach((dependency) => {
                      const isEmpty = dependency?.id.includes("dep");
                      if (isEmpty) {
                        let payload = {
                          layerRuleId: "00000000-0000-0000-0000-000000000000",
                          ddName: dependency.ddName,
                          minValue: dependency.minValue,
                          maxValue: dependency.maxValue,
                          modelId: rules?.modelId,
                        };
                        createLayerDependencyRequests.push(payload);
                      }
                    });
                  createLayerRuleRequests.push({
                    createLayerRuleRequest: layerPayload,
                    createLayerDependencyRequests:
                      createLayerDependencyRequests,
                  });
                  createLayerDependencyRequests = [];
                }
                if (newItem?.layerRuleId !== "") {
                  newItem.layerDependencies.length > 0 &&
                    newItem.layerDependencies.forEach((dependency) => {
                      const isEmpty = dependency?.id.includes("dep");
                      if (isEmpty) {
                        let payload = {
                          layerRuleId: newItem?.layerRuleId,
                          ddName: dependency.ddName,
                          minValue: dependency.minValue,
                          maxValue: dependency.maxValue,
                          modelId: rules?.modelId,
                        };
                        createLayerDependencyRequestsExitsLayers.push(payload);
                      }
                      if (!isEmpty) {
                        let updatePayload = {
                          layerDependencyId: dependency?.id,
                          layerRuleId: dependency?.layerRuleId,
                          ddName: dependency?.ddName,
                          minValue: dependency?.minValue,
                          maxValue: dependency?.maxValue,
                          modelId: rules?.modelId,
                        };
                        updateLayerDependencyRequests.push(updatePayload);
                      }
                    });
                }
              });
          } else if (isEmpty) {
            let newPayload = {
              drawingId: item.drawingId,
              name: item.layerName.trim(),
              alwaysOn: item.alwaysOn ? "-1" : 0,
              removeForDxf: item.removeForDxf ? 1 : 0,
              isCompareFullName: item.isCompareFullName,
            };
            const newlayerPayload = {
              layerId: "00000000-0000-0000-0000-000000000000",
            };

            createNewLayerDependencyRequests = [];
            createLayerRuleRequestWithDependencies = [];

            item.layerRules &&
              item.layerRules.length > 0 &&
              item.layerRules.forEach(async (newItem) => {
                newItem.layerDependencies.length > 0 &&
                  newItem.layerDependencies.forEach((dependency) => {
                    let dependencyPayload = {
                      layerRuleId: "00000000-0000-0000-0000-000000000000",
                      ddName: dependency.ddName,
                      minValue: dependency.minValue,
                      maxValue: dependency.maxValue,
                      modelId: rules?.modelId,
                    };
                    createNewLayerDependencyRequests.push(dependencyPayload);
                  });

                createLayerRuleRequestWithDependencies.push({
                  createLayerRuleRequest: newlayerPayload,
                  createLayerDependencyRequests:
                    createNewLayerDependencyRequests,
                });
                createNewLayerDependencyRequests = [];
              });

            // createLayerRuleRequestWithDependencies.push({
            //   createLayerRuleRequest: newlayerPayload,
            //   createLayerDependencyRequests: createNewLayerDependencyRequests,
            // });
            createLayerRequest.push({
              createLayerRequest: newPayload,
              createLayerRuleRequestWithDependencies:
                createLayerRuleRequestWithDependencies,
            });
          }
        }
      });

    const updateRequest = {
      createLayerRuleRequests,
      createLayerDependencyRequestsExitsLayers,
      updateLayerDependencyRequests,
      createLayerRequest,
    };
    console.log("payload: ", updateRequest);
    return updateRequest;
  };

  const updateLayes = (updateLayerDependencyRequests) => {
    const layerInfo = [...rulesState?.layers?.data?.layers];
    const oldData = [];
    layerInfo.length > 0 &&
      layerInfo.forEach(async (item, index) => {
        item.layerRules &&
          item.layerRules.length > 0 &&
          item.layerRules.forEach(async (newItem) => {
            if (newItem?.layerRuleId !== "") {
              newItem.layerDependencies.length > 0 &&
                newItem.layerDependencies.forEach((dependency) => {
                  const isEmpty = dependency?.id.includes("dep");
                  if (!isEmpty) {
                    let updatePayload = {
                      layerDependencyId: dependency?.id,
                      layerRuleId: dependency?.layerRuleId,
                      ddName: dependency?.ddName,
                      minValue: dependency?.minValue,
                      maxValue: dependency?.maxValue,
                      modelId: rules?.modelId,
                    };
                    oldData.push(updatePayload);
                  }
                });
            }
          });
      });
    const difference = _.differenceWith(
      updateLayerDependencyRequests,
      oldData,
      _.isEqual
    );
    return difference;
  };

  /* Save action */
  const onUpdateValue = async () => {
    try {
      const {
        createLayerRuleRequests,
        createLayerDependencyRequestsExitsLayers,
        updateLayerDependencyRequests,
        createLayerRequest,
      } = prepareRuleLayerRequest();
      const updatedValues = updateLayes(updateLayerDependencyRequests);
      const deleteLayers = [];
      let updateLayerData = [];
      const nfLayer = notFoundLayerData.map((ele) => ele.layerName);
      if (deleteFields.length > 0) {
        deleteFields.forEach((item) => {
          deleteLayers.push({ layerId: item.layerId });
        });
      }

      fields.forEach((ele) => {
        if (ele.alwaysOff && !ele?.isNotFound) {
          deleteLayers.push({ layerId: ele.layerId });
        }
      });

      updateLayers.forEach((ele) => {
        if (ele.alwaysOn == 1) ele.alwaysOn = "-1";

        if (
          !deleteLayers.map((eled) => eled.layerId).includes(ele.layedId) &&
          !ele.alwaysOff
        ) {
          updateLayerData.push(ele);
        }
      });

      const updateRequest = {
        drawingRuleRequest: {
          deleteDrawingRuleRequests: [],
          createDrawingRuleRequests: [],
        },
        drawingDependencyRequest: {
          deleteDrawingDependencyRequests: [],
          createDrawingDependencyRequests: [],
          updateDrawingDependencyRequests: [],
        },
        layerRequest: {
          createLayerRequests: createLayerRequest,
          deleteLayerRequests: deleteLayers,
          updateLayerRequests: updateLayerData,
        },
        layerRuleRequest: {
          deleteLayerRuleRequests: deleteLayerRuleRequests,
          createLayerRuleRequests: createLayerRuleRequests,
        },
        layerDependencyRequest: {
          deleteLayerDependencyRequests: deleteLayerDependencyRequests,
          createLayerDependencyRequests:
            createLayerDependencyRequestsExitsLayers,
          updateLayerDependencyRequests: updatedValues,
        },
      };

      if (copyDrawing) {
        // all found layer should be update
        let tempOld = newBackUpLayer.map((ele) => ele.old);
        let tempNew = newBackUpLayer.map((ele) => ele.new);
        let tempLayer = tempNew.map((ele) => ele.layerName.trim());
        // let oldDrawingId = newBackUpLayer[0].old.drawingId;

        let newUpdateLayerArr = [];
        let newDeleteLayerRuleArr = [];
        let newCreateLayerRuleArr = [];

        const updateReqLayer =
          updateRequest.layerRequest.updateLayerRequests.map((e) =>
            e?.name?.trim()
          );

        const deleteReqLayer =
          updateRequest.layerRuleRequest.deleteLayerRuleRequests.map(
            (e) => e?.layerRuleId
          );

        const createReqLayer =
          updateRequest.layerRuleRequest.createLayerRuleRequests.map(
            (e) => e?.createLayerRuleRequest?.layerId
          );

        fields.forEach((ele) => {
          if (tempLayer.includes(ele.layerName.trim())) {
            if (ele?.isOld) {
              //update layers
              let t = {
                layerId: ele.layerId,
                drawingId: backupDrawingId,
                name: ele.layerName,
                alwaysOn: ele.alwaysOn ? "-1" : 0,
                removeForDxf: ele.removeForDxf ? 1 : 0,
                isCompareFullName: ele.isCompareFullName,
              };
              newUpdateLayerArr.push(t);

              // create new layer rules
              if (ele.layerRules.length) {
                if (tempLayer.includes(ele.layerName.trim())) {
                  let layerRulesDependacy = [];

                  ele.layerRules.forEach((item) => {
                    item.layerDependencies.forEach((dependancy) => {
                      let d = {
                        layerRuleId: "00000000-0000-0000-0000-000000000000",
                        ddName: dependancy.ddName,
                        minValue: dependancy.minValue,
                        maxValue: dependancy.maxValue,
                        modelId: rules?.modelId,
                      };
                      layerRulesDependacy.push(d);
                    });

                    let dependancies = {
                      createLayerRuleRequest: {
                        layerId: ele.layerId,
                      },
                      createLayerDependencyRequests: layerRulesDependacy,
                    };

                    if (dependancies.createLayerDependencyRequests.length)
                      newCreateLayerRuleArr.push(dependancies);
                  });
                }
              }

              // delete existing layer rules
              let shoudlDelete = tempOld.filter(
                (z) => z.layerId.trim() === ele.layerId.trim()
              );
              if (shoudlDelete.length) {
                let [temp = null] = shoudlDelete;
                if (temp) {
                  const { layerRules = [] } = temp || {};
                  layerRules.forEach((deletLR) => {
                    newDeleteLayerRuleArr.push({
                      layerRuleId: deletLR.layerRuleId,
                    });
                  });
                }
              }
            }
          } else {
            if (updateReqLayer.includes(ele.layerName.trim())) {
              let t = {
                layerId: ele.layerId,
                drawingId: backupDrawingId,
                name: ele.layerName,
                alwaysOn: ele.alwaysOn ? "-1" : 0,
                removeForDxf: ele.removeForDxf ? 1 : 0,
                isCompareFullName: ele.isCompareFullName,
              };
              newUpdateLayerArr.push(t);
            }
          }
        });

        updateRequest.layerRequest.updateLayerRequests = newUpdateLayerArr;
        updateRequest.layerRequest.deleteLayerRequests = [];
        updateRequest.layerRuleRequest.createLayerRuleRequests =
          newCreateLayerRuleArr;
        updateRequest.layerRuleRequest.deleteLayerRuleRequests =
          newDeleteLayerRuleArr;
      }

      await updateRules(updateRequest);
      onCloseSelected({
        id: uuidv4(),
        isClosed: true,
      });
      if (!rulesState?.updateRules?.hasError) {
        setDeleteLayerRuleRequests([]);
        setDeleteLayerDependencyRequests([]);
        setSnackBar(
          true,
          "success",
          injectIntlTranslation(intl, "saveSuccess", constants.saveSuccess)
        );
      }
    } catch (error) {
      console.log(error);
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "somethingWentWrong",
          constants.somethingWentWrong
        )
      );
    }
  };

  useEffect(() => {
    window.onLayerSave = onUpdateValue;
    window.getLayersValue = () => {
      return fields;
    };
  }, [fields]);

  useEffect(() => {
    if (rulesState?.layers?.data && rulesState?.layers?.data?.layers) {
      setLayerLoading(true);
      getLayersFromS3();
      setIsNew(true);
      if (!copyDrawing) {
        setBackUpLayers(rulesState?.layers?.data?.layers);
      }
    }
  }, [rulesState?.layers?.data?.layers]);

  useEffect(() => {
    // setLoading(rulesState?.layers?.isLoading);
  }, [rulesState?.layers?.isLoading]);

  useEffect(() => {
    // setLoading(rulesState?.updateRules?.isLoading);
  }, [rulesState?.updateRules?.isLoading]);

  /* Update layer dependencies */
  const handleFieldChange =
    (index, ruleIndex, dependencyIndex, fieldName, isDiscrete) => (event) => {
      const newFields = JSON.parse(JSON.stringify(fields));
      const item = newFields[index].layerRules[ruleIndex].layerDependencies;
      if (fieldName === "ddName") {
        item[dependencyIndex][fieldName] = event;
        item[dependencyIndex]["minValue"] = "";
        item[dependencyIndex]["maxValue"] = "";
      } else if (fieldName === "minValue" && !isDiscrete) {
        item[dependencyIndex][fieldName] = event;
      } else if (fieldName === "maxValue" && !isDiscrete) {
        item[dependencyIndex][fieldName] = event;
      } else {
        item[dependencyIndex][fieldName] = event.target.value;
      }
      setFields(newFields);
      // if(item[dependencyIndex].id !== undefined){
      //   updateLayer(item[dependencyIndex]);
      // }
    };

  /* Update layer dependencies */
  const updateLayer = (field, propertyName, newValue) => {
    // const payload =  {
    let payload = {
      layerId: field?.layerId,
      drawingId: field?.drawingId,
      name: field?.layerName.trim(),
      alwaysOn: field.alwaysOn,
      removeForDxf: field?.removeForDxf,
      isCompareFullName: field?.isCompareFullName,
    };
    payload = { ...payload, [propertyName]: !newValue };
    payload.alwaysOn = payload.alwaysOn ? 1 : 0;
    payload.removeForDxf = payload.removeForDxf ? 1 : 0;
    payload.isCompareFullName = payload.isCompareFullName ? 1 : 0;
    if (updateLayers.length > 0) {
      const itemIndex = updateLayers.findIndex(
        (ele) => ele.layerId === field.layerId
      );
      if (itemIndex === -1) {
        updateLayers.push(payload);
      } else {
        updateLayers[itemIndex] = payload;
      }
    } else {
      updateLayers.push(payload);
    }
    setUpdateLayers(updateLayers);
  };

  /* Calling layerDependencies and updating into grid data*/
  const handletoggleOpen = async (field, propertyName, newValue) => {
    let updatedFields;
    if (propertyName == "toggleOpen" && !field.alwaysOn && !field.alwaysOff) {
      updatedFields = fields.map((obj) => {
        return obj.layerId === field?.layerId
          ? { ...obj, [propertyName]: !newValue }
          : obj;
      });
    } else if (propertyName == "alwaysOn") {
      updatedFields = fields.map((obj) => {
        return obj.layerId === field?.layerId
          ? {
              ...obj,
              [propertyName]: !newValue,
              toggleOpen: newValue,
              alwaysOff: false,
            }
          : obj;
      });
    } else if (propertyName == "toggleOpen" && field.alwaysOn) {
      updatedFields = fields.map((obj) => {
        return obj.layerId === field?.layerId
          ? { ...obj, [propertyName]: !newValue }
          : obj;
      });
    } else if (propertyName == "toggleOpen" && !field.alwaysOn) {
      updatedFields = fields.map((obj) => {
        return obj.layerId === field?.layerId
          ? { ...obj, toggleOpen: false }
          : obj;
      });
    } else if (isNew && propertyName === "alwaysOff") {
      const isChecked = !newValue;
      updatedFields = fields.map((obj) => {
        return obj.layerId === field?.layerId
          ? {
              ...obj,
              [propertyName]: isChecked,
              alwaysOn: false,
              isCompareFullName: false,
              removeForDxf: false,
              disabled: isChecked,
            }
          : obj;
      });
    } else {
      updatedFields = fields.map((obj) => {
        return obj.layerId === field?.layerId
          ? { ...obj, [propertyName]: !newValue }
          : obj;
      });
    }
    const isEmpty = field?.layerId.includes("dep");
    if (!isEmpty) {
      updateLayer(field, propertyName, newValue);
    }
    setFields(updatedFields);
    setIsUnsaveChanges(true);
  };

  /* Delete layer rule action */
  const deleteConfirm = (type, value, index, ruleIndex, dependencyIndex) => {
    setDeleteFlag(type);
    setShowDelete(true);
    setIndex(index);
    setRuleIndex(ruleIndex);
    setDependencyIndex(dependencyIndex);
    setSelectedLayer(value);
  };

  /* Delete API call*/
  const deleteRule = async () => {
    const gridData = JSON.parse(JSON.stringify(fields));
    if (deleteFlag === "ruleLayer") {
      gridData[index].layerRules.splice(ruleIndex, 1);
      if (selectedLayer.layerRuleId !== "") {
        deleteLayerRuleRequests.push({
          layerRuleId: selectedLayer.layerRuleId,
        });
      }
      setDeleteLayerRuleRequests(deleteLayerRuleRequests);
    } else if (deleteFlag === "dependencies") {
      gridData[index].layerRules[ruleIndex].layerDependencies.splice(
        dependencyIndex,
        1
      );
      const isEmpty = selectedLayer?.id.includes("dep");
      if (selectedLayer.id !== "" && !isEmpty) {
        deleteLayerDependencyRequests.push({
          layerDependencyId: selectedLayer.id,
        });
      }
      setDeleteLayerDependencyRequests(deleteLayerDependencyRequests);
    }
    setFields(gridData);

    setShowDelete(false);
  };

  const handleNewField = (index, ruleIndex) => {
    const gridData = JSON.parse(JSON.stringify(fields));
    const idText = "dep";
    const depId = idText.concat(uuidv4());
    gridData[index].layerRules[ruleIndex].layerDependencies.push({
      layerRuleId: "",
      modelId: rules?.modelId,
      ddName: "",
      minValue: "",
      maxValue: "",
      id: depId,
    });
    setFields(gridData);
  };

  /* add new rule set */
  const handleNewRuleLayer = async (item, index) => {
    const gridData = JSON.parse(JSON.stringify(fields));
    gridData[index].layerRules.push({
      layerRuleId: "",
      layerDependencies: [],
    });
    setFields(gridData);
  };

  const [sortType, setSortType] = useState("");

  const sortAcs = (sortType) => {
    if (sortType) {
      let temp = _.orderBy(fields, ["layerName"], [sortType]);
      setFields(temp);
    } else {
      let temp = _.orderBy(fields, ["layerId"], [sortType]);
      setFields(temp);
    }
  };

  const handleSorting = () => {
    if (sortType === "" || sortType === "desc") {
      setSortType("asc");
    } else if (sortType === "asc") {
      setSortType("desc");
    }
  };

  useEffect(() => {
    sortAcs(sortType);
  }, [sortType]);

  useEffect(() => {
    if (copyDrawing) {
      setSortType("");
    }
  }, [copyDrawing]);

  const isCopyStateUpdate = useMemo(() => {
    return copyState?.data && copyState?.origin === "LAYER";
  }, [copyState]);

  const handleCopyClick = (id = "") => {
    console.log(id?.layerRules);
    if (id) {
      setCopyState({
        origin: "LAYER",
        data: JSON.stringify(id?.layerRules || []),
      });
    }
  };

  const handlePasteRule = async (index) => {
    if (copyState) {
      const gridData = JSON.parse(JSON.stringify(fields));
      const copyFrom = JSON.parse(copyState.data);

      // gridData[index].layerRules.push({
      //   layerRuleId: "",
      //   layerDependencies: [],
      // });
      // setFields(gridData);

      const idText = "dep";
      const layerDepTemp = gridData[index]?.layerRules.length
        ? gridData[index]?.layerRules
        : [];

      if (copyFrom.length) {
        copyFrom.forEach((ele) => {
          const temp = [];

          if (ele?.layerDependencies?.length) {
            const { layerDependencies } = ele;
            layerDependencies.map((item) => {
              const { ddName = "", minValue = "", maxValue = "" } = item;
              const depId = idText.concat(uuidv4());

              temp.push({
                ddName,
                minValue,
                maxValue,
                drawingRuleId: "",
                ModelId: rules?.modelId,
                id: depId,
              });
            });
          }

          layerDepTemp.push({
            layerRuleId: "",
            layerDependencies: temp,
          });
        });
      }

      console.log("Update Data: ", gridData[index]);

      gridData[index]["layerRules"] = layerDepTemp;
      console.log(gridData);
      setFields(gridData);
    }
  };

  return (
    <div className="layer" style={{ paddingTop: "25px" }}>
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ flex: "1" }} className="drawing-header">
          {injectIntlTranslation(intl, "layersText", constants.layersText)}
        </div>
        <ExportRuleLayers
          data={[...fields, ...deleteFields]}
          drawingName={drawingName}
          modelName={miscState?.selectedModelName || "-"}
        />
      </div>
      <span id="simple-modal-sub-title" style={{ color: "#617080" }}>
        {subTitle}
      </span>
      <div
        style={{
          height: "100%",
          overflow: "auto",
          overflowX: "hidden",
          marginTop: "20px",
          height: "calc(100vh - 300px)",
        }}
      >
        {/* <form
          style={{
            textAlign: "center",
            scrollBehavior: "auto",
            marginTop: "10px",
            marginBottom: "24px",
            minHeight: "200px",
          }}
        > */}
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            spacing={1}
            container
            className={classes.layerContainer}
          >
            <Grid
              item
              className={classes.gridLayerColumns}
              xs={12}
              justify="center"
              container
              spacing={1}
              alignItems="center"
            >
              <div className={classes.divColumnHeaderLayer}>
                <Grid className={`${classes.header} ${classes.item}`} item>
                  <span
                    onClick={() => {
                      handleSorting();
                    }}
                    style={{ display: "flex", cursor: "pointer" }}
                  >
                    {injectIntlTranslation(
                      intl,
                      "layerNameLabel",
                      constants.layerNameLabel
                    )}
                    <SortIcon sortType={sortType} />
                  </span>
                </Grid>
                <Grid className={`${classes.headerLayer} ${classes.item}`} item>
                  {injectIntlTranslation(
                    intl,
                    "alwaysOnLabel",
                    constants.alwaysOnLabel
                  )}
                </Grid>
                <Grid className={`${classes.headerLayer} ${classes.item}`} item>
                  {injectIntlTranslation(
                    intl,
                    "removeForDXFLabel",
                    constants.removeForDXFLabel
                  )}
                </Grid>
                <Grid className={`${classes.headerLayer} ${classes.item}`} item>
                  {injectIntlTranslation(
                    intl,
                    "isCompareFullnameLabel",
                    constants.isCompareFullnameLabel
                  )}
                </Grid>
                <Grid className={`${classes.headerLayer} ${classes.item}`} item>
                  {injectIntlTranslation(
                    intl,
                    "alwaysOffLabel",
                    constants.alwaysOffLabel
                  )}
                </Grid>
              </div>
              <Grid className={`${classes.header} ${classes.item}`}></Grid>
            </Grid>
            {(loading || layerLoading) && ""}

            {(!loading || !layerLoading) &&
              fields.length > 0 &&
              fields.map((field, index) => {
                return (
                  <>
                    <Grid
                      className={classes.gridLayerColumnsData}
                      item
                      xs={12}
                      justify="center"
                      container
                      spacing={1}
                      alignItems="center"
                    >
                      <div className={classes.divColumnLayer}>
                        <Grid item className={`${classes.item}`}>
                          <GridLabel
                            value={injectIntlTranslation(
                              intl,
                              field.layerName,
                              field.layerName
                            )}
                            width="160px"
                          />
                        </Grid>
                        <Grid className={`${classes.itemLayer}`} item>
                          <Checkbox
                            checked={field.alwaysOn}
                            onChange={() =>
                              handletoggleOpen(
                                field,
                                "alwaysOn",
                                field.alwaysOn
                              )
                            }
                            name="alwaysOn"
                            disabled={field.disabled}
                            style={{ color: "#1891F6" }}
                          />
                        </Grid>
                        <Grid className={`${classes.itemLayer}`} item>
                          <Checkbox
                            checked={field.removeForDxf}
                            onChange={() =>
                              handletoggleOpen(
                                field,
                                "removeForDxf",
                                field.removeForDxf
                              )
                            }
                            name="removeForDxf"
                            disabled={field.disabled}
                            style={{ color: "#1891F6" }}
                          />
                        </Grid>
                        <Grid className={`${classes.itemLayer}`} item>
                          <Checkbox
                            checked={field.isCompareFullName}
                            onChange={() =>
                              handletoggleOpen(
                                field,
                                "isCompareFullName",
                                field.isCompareFullName
                              )
                            }
                            name="isCompareFullName"
                            disabled={field.disabled}
                            style={{ color: "#1891F6" }}
                          />
                        </Grid>
                        {isNew && (
                          <Grid className={`${classes.itemLayer}`} item>
                            <Checkbox
                              checked={field.alwaysOff}
                              onChange={() =>
                                handletoggleOpen(
                                  field,
                                  "alwaysOff",
                                  field.alwaysOff
                                )
                              }
                              name="alwaysOff"
                              style={{ color: "#1891F6" }}
                            />
                          </Grid>
                        )}
                      </div>
                      <Grid
                        item
                        xs={1}
                        className={`${classes.andIcon} ${classes.item}`}
                      >
                        {!field.alwaysOn && !field.alwaysOff && (
                          <button
                            type="button"
                            style={{
                              background: "transparent",
                              border: "none",
                            }}
                            onClick={() =>
                              handletoggleOpen(
                                field,
                                "toggleOpen",
                                field.toggleOpen
                              )
                            }
                          >
                            {!field.toggleOpen && (
                              <ArrowDropDown
                                style={{ color: "#333" }}
                              ></ArrowDropDown>
                            )}
                            {field.toggleOpen && (
                              <ArrowRight
                                style={{ color: "#333" }}
                              ></ArrowRight>
                            )}
                          </button>
                        )}
                      </Grid>
                    </Grid>
                    {field.toggleOpen && !field.alwaysOff && (
                      <div style={{ display: "flex", width: "100%" }}>
                        <div style={{ width: "250px", marginLeft: "auto" }}>
                          <Button
                            onClick={() => handleNewRuleLayer(field, index)}
                            className="newrule"
                            startIcon={<AddIcon fontSize="small" />}
                          >
                            {injectIntlTranslation(
                              intl,
                              "newRuleSetBtn",
                              constants.newRuleSetBtn
                            )}
                          </Button>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            color: "rgb(14, 59, 141)",
                            margin: "auto",
                            marginLeft: "0px",
                          }}
                        >
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleCopyClick(field);
                            }}
                          >
                            <FileCopyIcon
                              style={{
                                width: "15px",
                                height: "15px",
                                marginRight: "3px",
                                marginBottom: "-2px",
                              }}
                            />
                            <span>Copy All</span>
                          </div>
                          <div
                            style={{
                              cursor: "pointer",
                              marginright: "20px",
                              color: isCopyStateUpdate
                                ? "rgb(14, 59, 141"
                                : "gray",
                              pointerEvents: isCopyStateUpdate ? "" : "none",
                            }}
                            onClick={() => {
                              handlePasteRule(index);
                            }}
                          >
                            <ContentPasteIcon
                              style={{
                                width: "15px",
                                height: "15px",
                                marginRight: "3px",
                                marginBottom: "-2px",
                              }}
                            />
                            <span> Paste</span>
                          </div>
                        </div>
                      </div>
                    )}
                    {!field.alwaysOff && (
                      <div className="rules" key={index}>
                        {field.toggleOpen &&
                          field.layerRules &&
                          field.layerRules.length > 0 &&
                          field.layerRules.map((layer, ruleIndex) => {
                            return (
                              <Grid
                                container
                                spacing={1}
                                style={{ margin: "4px 0" }}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  spacing={1}
                                  container
                                  className={classes.container}
                                >
                                  <Grid
                                    item
                                    className={classes.gridColumns}
                                    xs={12}
                                    justify="center"
                                    container
                                    spacing={1}
                                    alignItems="center"
                                  >
                                    <Grid
                                      className={`${classes.header} ${classes.item}`}
                                    ></Grid>
                                    <div className={classes.divColumnHeader}>
                                      <Grid
                                        className={`${classes.header} ${classes.item}`}
                                        item
                                      >
                                        {injectIntlTranslation(
                                          intl,
                                          "DNameText",
                                          constants.DNameText
                                        )}
                                      </Grid>
                                      <Grid
                                        className={`${classes.header} ${classes.item}`}
                                        item
                                      >
                                        {injectIntlTranslation(
                                          intl,
                                          "min",
                                          constants.min
                                        )}
                                      </Grid>
                                      <Grid
                                        className={`${classes.header} ${classes.item}`}
                                        item
                                      >
                                        {injectIntlTranslation(
                                          intl,
                                          "max",
                                          constants.max
                                        )}
                                      </Grid>
                                      <Grid
                                        className={`${classes.header} ${classes.item}`}
                                        item
                                      >
                                        <DeleteIcon
                                          fontSize="small"
                                          style={{
                                            marginLeft: "5px",
                                            color: "rgba(0, 0, 0, 0.87)",
                                          }}
                                          onClick={() => {
                                            deleteConfirm(
                                              "ruleLayer",
                                              layer,
                                              index,
                                              ruleIndex
                                            );
                                          }}
                                        ></DeleteIcon>
                                      </Grid>
                                    </div>
                                  </Grid>
                                  {layer?.layerDependencies?.length > 0 &&
                                    layer?.layerDependencies?.map(
                                      (dependency, dependencyIndex) => {
                                        var isDiscrete = false;
                                        ddList.forEach((ele) => {
                                          if (
                                            ele.label === dependency?.ddName
                                          ) {
                                            isDiscrete =
                                              ele.columnType === "DISCRETE";
                                          }
                                        });
                                        return (
                                          <Grid
                                            className={classes.gridColumns}
                                            item
                                            xs={12}
                                            justify="center"
                                            container
                                            spacing={1}
                                            alignItems="center"
                                          >
                                            <Grid
                                              item
                                              xs={1}
                                              className={`${classes.andIcon} ${classes.item}`}
                                            >
                                              {dependencyIndex !== 0 && (
                                                <>
                                                  {injectIntlTranslation(
                                                    intl,
                                                    "and",
                                                    "and"
                                                  )}
                                                </>
                                              )}
                                            </Grid>
                                            <div
                                              className={classes.divColumn}
                                              key={dependency.id}
                                            >
                                              <Grid
                                                item
                                                className={`${classes.item}`}
                                                xs={5}
                                              >
                                                <DropdownSelect
                                                  size="small"
                                                  tab="RulesLayer"
                                                  id="outlined-basic"
                                                  searchPlaceHolderText="Search for a DD Name"
                                                  selectInfoText="Select a DD"
                                                  selectedValue={
                                                    dependency?.ddName
                                                  }
                                                  menuList={ddList}
                                                  textWidth="100px"
                                                  popperWidth="324px"
                                                  popperHeight="211px"
                                                  onChange={handleFieldChange(
                                                    index,
                                                    ruleIndex,
                                                    dependencyIndex,
                                                    "ddName"
                                                  )}
                                                />
                                              </Grid>
                                              <Grid
                                                className={`${classes.item}`}
                                                item
                                                xs={3}
                                              >
                                                {isDiscrete ? (
                                                  <TextField
                                                    size="small"
                                                    id="outlined-basic"
                                                    placeholder=""
                                                    label=""
                                                    value={dependency.minValue}
                                                    onChange={handleFieldChange(
                                                      index,
                                                      ruleIndex,
                                                      dependencyIndex,
                                                      "minValue",
                                                      isDiscrete
                                                    )}
                                                  />
                                                ) : (
                                                  <AutocompleteSelect
                                                    data={ddList}
                                                    ddName={dependency?.ddName}
                                                    value={dependency?.minValue}
                                                    setIsUnsaveChanges={
                                                      setIsUnsaveChanges
                                                    }
                                                    onChange={handleFieldChange(
                                                      index,
                                                      ruleIndex,
                                                      dependencyIndex,
                                                      "minValue"
                                                    )}
                                                  />
                                                )}
                                              </Grid>
                                              <Grid
                                                className={`${classes.item}`}
                                                item
                                                xs={3}
                                              >
                                                {isDiscrete ? (
                                                  <TextField
                                                    size="small"
                                                    id="outlined-basic"
                                                    placeholder=""
                                                    label=""
                                                    value={dependency.maxValue}
                                                    onChange={handleFieldChange(
                                                      index,
                                                      ruleIndex,
                                                      dependencyIndex,
                                                      "maxValue",
                                                      isDiscrete
                                                    )}
                                                  />
                                                ) : (
                                                  <AutocompleteSelect
                                                    data={ddList}
                                                    ddName={dependency?.ddName}
                                                    value={dependency?.maxValue}
                                                    setIsUnsaveChanges={
                                                      setIsUnsaveChanges
                                                    }
                                                    onChange={handleFieldChange(
                                                      index,
                                                      ruleIndex,
                                                      dependencyIndex,
                                                      "maxValue"
                                                    )}
                                                  />
                                                )}
                                              </Grid>
                                              <Grid
                                                className={`${classes.item}`}
                                                item
                                                xs={1}
                                              >
                                                <DeleteIcon
                                                  color="enabled"
                                                  fontSize="small"
                                                  onClick={() => {
                                                    deleteConfirm(
                                                      "dependencies",
                                                      dependency,
                                                      index,
                                                      ruleIndex,
                                                      dependencyIndex
                                                    );
                                                  }}
                                                />
                                              </Grid>
                                            </div>
                                          </Grid>
                                        );
                                      }
                                    )}
                                  {!field.alwaysOff && (
                                    <Grid item style={{ margin: "0 auto" }}>
                                      <Button
                                        onClick={() => {
                                          handleNewField(index, ruleIndex);
                                        }}
                                        className={classes.addNewRule}
                                        startIcon={<AddIcon fontSize="small" />}
                                      >
                                        {injectIntlTranslation(
                                          intl,
                                          "newRuleBtn",
                                          constants.newRuleBtn
                                        )}
                                      </Button>
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>
                            );
                          })}
                      </div>
                    )}
                  </>
                );
              })}
            {!loading && deleteFields.length > 0 && (
              <span className="detected-layers">
                {deleteFields.length}{" "}
                {injectIntlTranslation(
                  intl,
                  "obseleteLabel",
                  constants.obseleteLabel
                )}{" "}
                {deleteFields.length > 1 ? "Layers" : "Layer"}{" "}
                {injectIntlTranslation(
                  intl,
                  "detectedLabel",
                  constants.detectedLabel
                )}
              </span>
            )}
            {!loading &&
              deleteFields.length > 0 &&
              deleteFields.map((field, index) => {
                return (
                  <>
                    <Grid
                      className={classes.gridLayerColumnsData}
                      item
                      xs={12}
                      justify="center"
                      container
                      spacing={1}
                      alignItems="center"
                    >
                      <div className={classes.divColumnLayer}>
                        <Grid item className={`${classes.item}`}>
                          <GridLabel value={field.layerName} width="160px" />
                        </Grid>
                        <Grid className={`${classes.itemLayer}`} item>
                          <Checkbox
                            checked={field.alwaysOn}
                            onChange={() =>
                              handletoggleOpen(
                                field,
                                "alwaysOn",
                                field.alwaysOn
                              )
                            }
                            name="alwaysOn"
                            disabled={field.disabled}
                            style={{ color: "#1891F6" }}
                          />
                        </Grid>
                        <Grid className={`${classes.itemLayer}`} item>
                          <Checkbox
                            checked={field.removeForDxf}
                            onChange={() =>
                              handletoggleOpen(
                                field,
                                "removeForDxf",
                                field.removeForDxf
                              )
                            }
                            name="removeForDxf"
                            disabled={field.disabled}
                            style={{ color: "#1891F6" }}
                          />
                        </Grid>
                        <Grid className={`${classes.itemLayer}`} item>
                          <Checkbox
                            checked={field.isCompareFullName}
                            onChange={() =>
                              handletoggleOpen(
                                field,
                                "isCompareFullName",
                                field.isCompareFullName
                              )
                            }
                            name="isCompareFullName"
                            disabled={field.disabled}
                            style={{ color: "#1891F6" }}
                          />
                        </Grid>
                        <Grid className={`${classes.itemLayer}`} item>
                          <Checkbox
                            checked={field.alwaysOff}
                            onChange={() =>
                              handletoggleOpen(
                                field,
                                "alwaysOff",
                                field.alwaysOff
                              )
                            }
                            name="alwaysOff"
                            className={field.disabled ? "disabled" : ""}
                            disabled={field.disabled}
                            style={{ color: "#1891F6" }}
                          />
                        </Grid>
                      </div>
                    </Grid>
                  </>
                );
              })}
          </Grid>
        </Grid>
        {/* </form> */}
      </div>

      <WarningPopup
        open={showDelete}
        onClose={() => setShowDelete(false)}
        title={injectIntlTranslation(
          intl,
          "deleteConfirmTitle",
          constants.deleteConfirmTitle
        )}
        description={
          <>
            {injectIntlTranslation(
              intl,
              "deleteConfirmText",
              constants.deleteConfirmText
            )}{" "}
            <b>{selectedLayer?.ddName}</b>?
          </>
        }
        saveButtonLabel={injectIntlTranslation(
          intl,
          "deleteBtnLabel",
          constants.deleteBtnLabel
        )}
        onSave={() => {
          deleteRule();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  layerState: state.layers,
  rulesState: state.rules,
  miscState: state.misc,
  dataDescriptionState: state.data_description,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getLayers: async (id) => dispatch(layerAction.getLayers(id)),
    updatelayerRules: async (data) =>
      dispatch(layerAction.updatelayerRules(data)),
    getLayerRules: async (layedId) =>
      dispatch(layerAction.getLayerRules(layedId)),
    deleteLayerRule: async (requestPayload) =>
      dispatch(layerAction.deleteLayerRule(requestPayload)),
    createLayerRules: async (requestPayload) =>
      dispatch(layerAction.createLayerRules(requestPayload)),
    updateRules: async (requestPayload) =>
      dispatch(ruleAction.updateRules(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Layers));
